import { useRef } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import autocallLogo from '@/assets/img/header/autocall.png'
import arrow from '@/assets/img/header/drawer_arrow.svg'
import xBtn from '@/assets/img/header/sidetab_xbtn.png'
import { JOIN_PARTNER_URL } from '@/features/join/pages/JoinPartnerPage'
import { useExtractRoute } from '@/shared/hooks'
import { usagetoggle } from '@/shared/recoil/common/atom'
import { monitoredReplace } from '@/shared/utils/sentry/navigation'
import { HeaderContainer } from '@/styles/Common/header_styled'

const Header = () => {
  const navigate = useNavigate()
  const routes = useExtractRoute('header')
  const inputRef: any = useRef(null)
  const inputRef2: any = useRef(null)
  const { pathname } = useLocation()
  const [tabIdx, setTabIdx] = useRecoilState(usagetoggle)

  const HandelLabel = () => {
    if (inputRef.current) inputRef.current.checked = false
    if (inputRef2.current) inputRef2.current.checked = false
  }
  return (
    <HeaderContainer>
      <div className="header-contents">
        <div className="img-container">
          <NavLink to="">
            <img src={autocallLogo} alt="autocall logo" />
          </NavLink>
        </div>
        {routes.map((route) => (
          <NavLink
            className={pathname === '/' ? 'header-nav-item' : 'header-nav-item select'}
            to={route.path}
            key={route.path}
          >
            {route.meta.title}
          </NavLink>
        ))}
        <NavLink
          className={pathname === '/' ? 'header-mypage-btn' : 'header-mypage-btn select'}
          to="mypage"
        >
          마이페이지
        </NavLink>
        <a className="header-nav-item-mobile" href={JOIN_PARTNER_URL}>
          <span>서비스 가입</span>
        </a>
        <input type="checkbox" id="navInput" />
        <label className="hambugerbtn" htmlFor="navInput" onClick={HandelLabel}>
          <div />
          <div />
          <div />
        </label>
        <nav id="nav">
          <label className="Xbtn" htmlFor="navInput">
            <img src={xBtn} alt="Xbtn" />
          </label>
          <ul>
            <li>
              <a className={`drawer-nav-item ${pathname === '/mypage' && 'active'}`}>
                <label
                  onClick={() => {
                    navigate('/mypage')
                  }}
                  htmlFor="navInput"
                >
                  마이페이지
                </label>
              </a>
            </li>
            <li>
              <a className={`drawer-nav-item ${pathname === '/join' && 'active'}`}>
                <label
                  onClick={() => {
                    window.location.href = JOIN_PARTNER_URL
                  }}
                  htmlFor="navInput"
                >
                  서비스 가입
                </label>
              </a>
            </li>
            <li>
              <input type="checkbox" id="nav-menu2" ref={inputRef} />
              <label className="nav-menu" htmlFor="nav-menu2">
                서비스 이용안내
                <img src={arrow} alt="arrow" />
              </label>
              <ul className="sub-menu-ul">
                <li>
                  <a className={`sub-menu ${pathname === '/usage' && tabIdx === 0 && 'active'}`}>
                    <label
                      onClick={() => {
                        navigate('/usage')
                        setTabIdx(0)
                      }}
                      htmlFor="navInput"
                    >
                      오토콜 알아보기
                    </label>
                  </a>
                </li>
                <li>
                  <a className={`sub-menu ${pathname === '/usage' && tabIdx === 1 && 'active'}`}>
                    <label
                      onClick={() => {
                        navigate('/usage')
                        setTabIdx(1)
                      }}
                      htmlFor="navInput"
                    >
                      ARS호출방법
                    </label>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a className={`drawer-nav-item ${pathname === '/sticker' && 'active'}`}>
                <label
                  onClick={() => {
                    navigate('/sticker')
                  }}
                  htmlFor="navInput"
                >
                  오토콜 주차스티커
                </label>
              </a>
            </li>
            <li>
              <a className={`drawer-nav-item ${pathname === '/qr' && 'active'}`}>
                <label
                  onClick={() => {
                    navigate('/qr')
                  }}
                  htmlFor="navInput"
                >
                  QR 인쇄
                </label>
              </a>
            </li>
            <li>
              <a
                className={`drawer-nav-item ${
                  ['/notice', '/news', '/faq', '/qna', '/refund'].some((path) =>
                    pathname.startsWith(path),
                  ) && 'active'
                }`}
              >
                <label
                  onClick={() => {
                    navigate('/notice')
                  }}
                  htmlFor="navInput"
                >
                  고객지원
                </label>
              </a>
            </li>
            <li>
              <a className={`drawer-nav-item ${pathname === '/cancel' && 'active'}`}>
                <label
                  onClick={() => {
                    navigate('/cancel')
                  }}
                  htmlFor="navInput"
                >
                  서비스 해지
                </label>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </HeaderContainer>
  )
}

export default Header
